<template>
    <div class="IperMatrizPeligrosEmpresa">
        <div v-if="empresaTemp.nombre">{{ empresaTemp.nombre }}</div>
        <div v-else><i class="fas fa-minus"></i></div>
    </div>
</template>

<script>
import { db } from '@/firebase'
export default {
    name: "IperMatrizPeligrosEmpresa",

    props: {
        empresa: Object,
    },

    data() {
        return {
            empresaTemp: JSON.parse(JSON.stringify(this.empresa))
        }
    },

    watch: {
        async empresa() {
            this.empresaTemp = JSON.parse(JSON.stringify(this.empresa));
        },
    }
}
</script>

<style scoped>
@keyframes loadingAnimation {
    0% {
        background-position: 0% 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0% 50%;
    }
}

.cargando__Texto {
    display: block;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 1em;
}

.cargando__Texto {
    background: linear-gradient(90deg, rgba(240, 240, 240, 1), rgb(200, 199, 199));
    background-size: 400% 400%;
    animation: loadingAnimation 3s ease-in-out infinite;
}
</style>